/** The handle the server would derive from an agent's name; shown as the placeholder until one is typed. */
export const suggestHandle = (name: string) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/^[^a-z]+/, "")
    .replace(/-+$/g, "")
    .slice(0, 31);
